<style scoped>
img {
  width:60%

}

</style>

<template>
  <v-stepper 
    v-model="step" 
    style="height:100%;overflow-y:scroll;overflow-x:scroll;max-width:100%;margin-right:1rem;" 
    class="elevation-0"
    alt-labels
  >
    <v-stepper-header>
      <v-stepper-step :complete="step>1"  step="1">Get device ID</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step>2"  step="2">Register device</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step :complete="step>3" step="3">Configure device</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step  step="4">Reboot device</v-stepper-step>
      <v-divider></v-divider>
    </v-stepper-header>

    <v-stepper-items class="subheading text-xs-left ">
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;margin-top:1.5rem;z-index:10" @click="step++; step = (step==5)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>
      <v-btn fab dark color="#FFD300" style="color:#002052;position:absolute;right:0;bottom:0;z-index:10" @click="step++; step = (step==5)?1:step">
        <v-icon dark>fast_forward</v-icon>
      </v-btn>
  
      <v-stepper-content step="1" >
        <v-card>
          <v-card-title  style="background-color:#39a9dc">
            <h2 class="title white--text font-weight-light">Get device ID</h2>
          </v-card-title>
          <v-container>
              <v-layout row wrap>
                <v-flex xs12>
                <b>a</b>. Connect device to the PC via USB, flash FP-ATR-LTE1 binary file and reboot
                </v-flex>
                <v-flex xs12>
                <b>b</b>. Open serial terminal (e.g. TeraTerm) to inspect device log
                </v-flex>
                <v-flex xs12>
                  <img
                     
                    src="@/assets/howto/serialportsetup.png" />
                </v-flex>
                <v-flex xs12>
                <b>c</b>. Copy <b>device ID</b>
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card>
          <v-card-title style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Register device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Register device with:
                  <ul>
                    <li>human-friendly label</li>
                    <li>unique ID got from terminal</li>
                    <li><i>"create new device certificate and key"</i> option checked</li>
                  </ul>
                </v-flex>
                <v-flex>
                  <img  src="@/assets/howto/registerltedevice.png" />
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>


      <v-stepper-content step="3">
        <v-card>
          <v-card-title   style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Configure device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Via serial terminal, set private-key and certificate PEM strings got after registration
                </v-flex>
                <v-flex xs12>
                  <img  src="@/assets/howto/downloadcredentials.png" />
                </v-flex>
                <v-flex xs12>
                  <img  src="@/assets/howto/ltecredentials.png" />
                </v-flex>
                <v-flex xs12>
                  <img  src="@/assets/howto/flashcredentials.png" />
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

      <v-stepper-content step="4">
        <v-card>
          <v-card-title   style="background-color:#39a9dc">
            <v-icon
              class="mr-3"
              dark
              size="42"
            >
              mdi-email-outline
            </v-icon>
            <h2 class="title white--text font-weight-light">Reboot device</h2>
          </v-card-title>
          <v-container>
            <v-layout row wrap>
                <v-flex xs12 >
                  Reboot device and start monitoring.
                </v-flex>
              </v-layout>
          </v-container>
        </v-card>
      </v-stepper-content>

    </v-stepper-items>
  </v-stepper>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState(
      {
          http: state => state.metadata.backendApi.http[state.metadata.env]
      }
    )
  },
  data(){
    return {
      step: 0
    }
  }
}
</script>